<div class="login">

  <mat-card>
    <mat-card-header>
      <mat-card-title style="margin-bottom: 2rem">Sign In</mat-card-title>
    </mat-card-header>

    <mat-card-content>

      <form [formGroup]="form" #loginForm class="form" >
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput type="text" formControlName="email" (keyup.enter)="login()" autocomplete="on"/>
            @if (form.get('email')?.hasError('required')) {
              <mat-error>Email is required field</mat-error>
            }
          </mat-form-field>
        </div>
        
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input matInput type="password" formControlName="password" (keyup.enter)="login()"/>
            @if (form.get('password')?.hasError('required')) {
              <mat-error>Password is a required field</mat-error>
            }
          </mat-form-field>
        </div>
      </form>

    </mat-card-content>

    <mat-card-actions class="login-actions">
      <lib-button
      class="login-button"
      [disabled]="form.invalid || loading"
      [fullWidth]="true"
      (click)="login()">
        Sign In
      </lib-button>

      @if (showOkta) {
        <!-- Okta login bar -->
        <button
         type="button"
         class="okta-login-bar"
         (click)="login2()" 
         [disabled]="loading || oktaService.getIsAuthenticated()"
        >
          <img class="okta-logo" src="assets/okta-icon.svg" alt="Okta" />
          <span>Sign in with Okta</span>
        </button>
        <small class="okta-note">Okta for Cigna Only</small>
      }

      <a href="/forgot-password" class="forgot-password-btn">Don't know your password?</a>
      <a href="#" class="forgot-password-btn" (click)="$event.preventDefault(); consent.reset()">Manage cookie settings</a>
    </mat-card-actions>

    <mat-card-footer>
      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    </mat-card-footer>
  </mat-card>
  
  @if (login_invalid) {
    <div class="incorrect-passw">
      <mat-icon class="error-icon">error_outline</mat-icon>
      <p>Incorrect email address or password, please try again.</p>
    </div>
  }

</div>